import { Component, Input, OnInit } from '@angular/core';
import { CognitoService } from '../services/cognito.service';
import { NotificationsService } from '../services/notifications/notifications.service';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.css']
})
export class NotificacionesComponent implements OnInit {
  @Input() data: any;
  constructor(
    private notificationsService: NotificationsService,
    private userService: CognitoService
  ) {}
  moreDetails: boolean = false;
  usuario: string = '';

  ngOnInit(): void {
    /*     this.userService.getAuthenticatedUser().then((data) => {
      this.usuario = `${data.attributes.middle_name} ${data.attributes.family_name}`;
    }); */

    this.usuario = `${localStorage.getItem('nombre')} ${localStorage.getItem('apellido')}`;
  }

  handleSendToSales(id: string, area: string) {
    if (!this.data.readOp) {
      this.data.readOp = this.usuario;
      this.notificationsService
        .readNotificationById(id, this.usuario, area)
        .subscribe({
          next: (read) => {
            console.log('Resultado de la notificación:', read);
          },
          error: (error) => {
            console.error('Error al leer la notificación:', error);
          }
        });
    }
  }

  ChangeMoreDetails() {
    this.moreDetails = !this.moreDetails;
  }
}
